import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import coaster from '../../img/coaster.png';
import enEsperaImg from '../../img/enEsperaImg.png';
import repoBaseExitoso from '../../img/repoBaseExito.png';
import viajeAsignadoImg from '../../img/viajeAsignadoImg.png';
import baseImg from '../../img/baseImg.png';
import errorImg from '../../img/errorImg.png';
import viajeImg from '../../img/viajeImg.png';
import qrImg from '../../img/qrImg.png';
import abordarPasajeroImg from '../../img/abordarPasajeroImg.png';
import exitoImg from '../../img/exitoImg.png';
import firebase from 'firebase';
import Modal_Conductores from './Modal_Conductores';

const Mapa = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={15}
    defaultCenter={props.userLocation}
    center={props.userLocation}
    options={{
      streetViewControl: false,
      mapTypeControl: false,
    }}
  >
    {props.userLocation && (
      <Marker
        position={props.userLocation}
        icon={{
          url: coaster,
          scaledSize: new window.google.maps.Size(35, 40),
        }}
      />
    )}
  </GoogleMap>
));

class Empleados_Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userLocation: null,
      loading: true,
      headerHeight: this.getHeaderHeight(),
      bases: [],
      baseActu: '',
      origenName: '',
      capacidadVehi: '',
      idOrDui: '',
      kmInicial: '',
      kmFinal: '',
      comentario: '',
      nombreCompleto: '',
      capacidadRestante: 0,
      pasajerosAbordados: '',
      pasajeroTemporal: null,
      showEnEspera: false,
      showEmpleadosHome: true,
      showReporteBaseExito: false,
      showReporteBaseError: false,
      showReporteBaseSeleccion: false,
      showViajeAsignado: false,
      showBtnViajeAsignado: false,
      showPasajeros: false,
      showAbordarPasajero: false,
      showLimiteCapacidad: false,
      showKilometrajeInicial: false,
      showViajeIniciado: false,
      showPasajerosViajeIniciado: false,
      showKilometrajeFinal: false,
      showBtnViajeAsignadoIniciado: false
    };
  }

  componentDidMount() {
    // Obtener el usuario logeado actual
    const currentUser = firebase.auth().currentUser;
    if (currentUser) {
      //console.log("Usuario logeado:", "correo:", currentUser.email, "uid:", currentUser.uid);

      // Obtener el vehículo del empleado y su capacidad
      firebase.database().ref(`Empleados/${currentUser.uid}`).once('value').then(async (snapshot) => {
        const empleadoData = snapshot.val();
        if (empleadoData && empleadoData.vehiculo) {
          const vehiculoSnapshot = await firebase.database().ref(`Vehiculos/${empleadoData.vehiculo}`).once('value');
          if (vehiculoSnapshot.exists()) {
            const vehiculoData = vehiculoSnapshot.val();
            this.setState({ capacidadVehi: vehiculoData.capacidad, initialLoad: true }, () => {
              // Escuchar cambios en el campo ViajeActualE del usuario logeado
              this.viajeActualERef = firebase.database().ref(`Empleados/${currentUser.uid}/ViajeActualE`);
              this.viajeActualERef.on('value', async (snapshot) => {
                const viajeActualE = snapshot.val();
                if (viajeActualE && viajeActualE !== 'ninguno') {
                  const viajeRef = firebase.database().ref(`AsignacionViajes/${viajeActualE}`);

                  // Escuchar cambios en los campos viajeIniciado y viajeFinalizado
                  viajeRef.on('value', async (snapshot) => {
                    const viajeData = snapshot.val();

                    // Verificar el estado del viaje
                    if (viajeData.viajeFinalizado) {
                      //console.log("El viaje ya estaba finalizado");
                      this.setState({
                        showPasajerosViajeIniciado: false,
                        showBtnViajeAsignadoIniciado: false,
                        showViajeAsignado: false,
                        showEnEspera: false,
                        showEmpleadosHome: false,
                        showReporteBaseExito: false,
                        showReporteBaseError: false,
                        showPasajeros: false,
                        showAbordarPasajero: false,
                        showKilometrajeInicial: false,
                        showViajeIniciado: false,
                        showKilometrajeFinal: false,
                        showBtnViajeAsignado: false
                      });
                      return;
                    } else if (viajeData.viajeIniciado) {
                      this.setState((prevState) => ({
                        origenName: viajeData.nameDes,
                        showPasajerosViajeIniciado: prevState.initialLoad,
                        showBtnViajeAsignadoIniciado: true,
                        showViajeAsignado: false,
                        showEnEspera: false,
                        showEmpleadosHome: false,
                        showReporteBaseExito: false,
                        showReporteBaseError: false,
                        showPasajeros: false,
                        showAbordarPasajero: false,
                        showKilometrajeInicial: false,
                        showViajeIniciado: false,
                        showKilometrajeFinal: false,
                        showBtnViajeAsignado: false
                      }));

                      // Escuchar cambios en los pasajeros abordados en tiempo real
                      this.listenToPasajeros(viajeActualE);
                      return;
                    }

                    const cantidadEmple = viajeData.emple ? Object.keys(viajeData.emple).length : 0;
                    const capacidadRestante = this.state.capacidadVehi - cantidadEmple;

                    // Construir la lista de nombres de pasajeros abordados
                    let pasajerosAbordados = '';
                    if (viajeData.emple) {
                      const empleados = Object.values(viajeData.emple);
                      for (const empleado of empleados) {
                        const empleadoSnapshot = await firebase.database().ref(`Clientes/${empleado.idEmple}`).once('value');
                        if (empleadoSnapshot.exists()) {
                          const empleadoData = empleadoSnapshot.val();
                          pasajerosAbordados += `${empleadoData.nombre} ${empleadoData.apellido}, `;
                        }
                      }
                      // Eliminar la última coma y espacio
                      pasajerosAbordados = pasajerosAbordados.slice(0, -2);
                    }

                    //console.log("cantidadEmple", cantidadEmple, "capacidadVehi", this.state.capacidadVehi, "Capacidad restante:", capacidadRestante);

                    this.setState((prevState) => ({
                      origenName: viajeData.nameDes,
                      showViajeAsignado: prevState.initialLoad,
                      showBtnViajeAsignado: true,
                      showEnEspera: false,
                      showEmpleadosHome: false,
                      showReporteBaseExito: false,
                      showReporteBaseError: false,
                      showPasajeros: false,
                      showAbordarPasajero: false,
                      showKilometrajeInicial: false,
                      showViajeIniciado: false,
                      showKilometrajeFinal: false,
                      showBtnViajeAsignadoIniciado: false,
                      cantidadEmple: cantidadEmple,
                      capacidadRestante: capacidadRestante,
                      pasajerosAbordados: pasajerosAbordados,
                      initialLoad: false // Desactivar la bandera después de la primera carga
                    }));

                    // Escuchar cambios en los pasajeros abordados en tiempo real
                    this.listenToPasajeros(viajeActualE);
                  });
                }
              });
            });
          }
        }
      });

      // Verificar si el usuario ya se ha reportado en LaboresEmpresa
      firebase.database().ref('LaboresEmpresa')
        .orderByChild('emple')
        .equalTo(currentUser.uid)
        .once('value')
        .then(snapshot => {
          if (snapshot.exists()) {
            // Verificar si no tiene un viaje asignado
            const reporte = snapshot.val();
            const reporteKey = Object.keys(reporte)[0];
            const reporteData = reporte[reporteKey];
            if (reporteData.estado === "true" && (!reporteData.viajeAsignado || reporteData.viajeAsignado === 'ninguno')) {
              this.setState({
                showEnEspera: true,
                showViajeAsignado: false,
                showBtnViajeAsignado: false,
                showEmpleadosHome: false,
                showReporteBaseExito: false,
                showReporteBaseError: false,
                showPasajeros: false,
                showAbordarPasajero: false
              });
            }
          }
        });
    } else {
      console.log("No hay usuario logeado.");
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          this.setState({
            userLocation: { lat: latitude, lng: longitude },
            loading: false,
          });
        },
        (error) => {
          console.error("Error obteniendo la ubicación: ", error);
          this.setState({ loading: false });
        }
      );
    } else {
      console.error("Geolocalización no es soportada por este navegador.");
      this.setState({ loading: false });
    }

    window.addEventListener('resize', this.updateHeaderHeight);
    firebase.database().ref('Bases').once('value').then(snap => {
      let bases = [];
      snap.forEach(element => {
        let datos = element.val();
        if (datos.estado === 'activa') {
          datos.key = element.key;
          bases.push(datos);
        }
      });
      this.setState({ bases });
    });
  }

  listenToPasajeros = (viajeActualE) => {
    const viajeRef = firebase.database().ref(`AsignacionViajes/${viajeActualE}/emple`);
    viajeRef.on('value', async (snapshot) => {
      const viajeData = snapshot.val();
      let pasajerosAbordados = '';
      let cantidadEmple = 0;
      if (viajeData) {
        const empleados = Object.values(viajeData);
        cantidadEmple = empleados.length;
        for (const empleado of empleados) {
          const empleadoSnapshot = await firebase.database().ref(`Clientes/${empleado.idEmple}`).once('value');
          if (empleadoSnapshot.exists()) {
            const empleadoData = empleadoSnapshot.val();
            pasajerosAbordados += `${empleadoData.nombre} ${empleadoData.apellido}<br>`;
          }
        }
        // Eliminar la última etiqueta <br>
        pasajerosAbordados = pasajerosAbordados.slice(0, -4);
      }
      const capacidadRestante = this.state.capacidadVehi - cantidadEmple;
      this.setState({ pasajerosAbordados, cantidadEmple, capacidadRestante });
    });
  }

  agregarPasajero = async () => {
    let { idOrDui, capacidadRestante } = this.state;

    // Verificar si se ha alcanzado el límite de capacidad
    if (capacidadRestante <= 0) {
      this.setState({ showLimiteCapacidad: true, showAbordarPasajero: false });
      return;
    }

    try {
      // Buscar el cliente por numero_empleado y dui en paralelo
      const [clienteNumeroEmpleadoSnapshot, clienteDuiSnapshot] = await Promise.all([
        firebase.database().ref('Clientes').orderByChild('numero_empleado').equalTo(idOrDui).once('value'),
        firebase.database().ref('Clientes').orderByChild('dui').equalTo(idOrDui).once('value')
      ]);

      let clienteData = null;
      let clienteId = null;

      // Verificar si se encontró el cliente por numero_empleado
      if (clienteNumeroEmpleadoSnapshot.exists()) {
        clienteNumeroEmpleadoSnapshot.forEach(childSnapshot => {
          clienteData = childSnapshot.val();
          clienteId = childSnapshot.key;
        });
      }

      // Si no se encontró por numero_empleado, verificar por dui
      if (!clienteData && clienteDuiSnapshot.exists()) {
        clienteDuiSnapshot.forEach(childSnapshot => {
          clienteData = childSnapshot.val();
          clienteId = childSnapshot.key;
        });
      }

      if (!clienteData) {
        this.setState({ showErrorAbordarPasajero: true, showAbordarPasajero: false });
        return;
      }

      const currentUser = firebase.auth().currentUser;
      if (!currentUser) {
        console.log("No hay usuario logeado.");
        return;
      }

      const viajeActualERef = firebase.database().ref(`Empleados/${currentUser.uid}/ViajeActualE`);
      const viajeActualESnapshot = await viajeActualERef.once('value');
      const viajeActualE = viajeActualESnapshot.val();

      if (!viajeActualE || viajeActualE === 'ninguno') {
        console.log("No hay viaje asignado.");
        return;
      }

      const pasajeroData = {
        horaSubida: Date.now(),
        idEmple: clienteId,
        subio: true
      };

      // Guardar el pasajero temporalmente en el estado
      this.setState({
        showExitoAbordarPasajero: true,
        showAbordarPasajero: false,
        nombreCompleto: `${clienteData.nombre} ${clienteData.apellido}`,
        pasajeroTemporal: { viajeActualE, clienteId, pasajeroData }
      });
    } catch (error) {
      console.error("Error al agregar pasajero:", error);
    }
  }

  handleBtnIniciarViajeKmClick = async () => {
    const { kmInicial } = this.state;

    if (!kmInicial) {
      console.error("Kilometraje inicial no puede estar vacío.");
      return;
    }

    const confirmacion = window.confirm("¿Seguro que desea iniciar el viaje?");
    if (!confirmacion) {
      return;
    }

    try {
      const currentUser = firebase.auth().currentUser;
      if (!currentUser) {
        console.log("No hay usuario logeado.");
        return;
      }

      const viajeActualERef = firebase.database().ref(`Empleados/${currentUser.uid}/ViajeActualE`);
      const viajeActualESnapshot = await viajeActualERef.once('value');
      const viajeActualE = viajeActualESnapshot.val();

      if (!viajeActualE || viajeActualE === 'ninguno') {
        console.log("No hay viaje asignado.");
        return;
      }

      const viajeData = {
        kmInicial: kmInicial,
        horaIni: Date.now(),
        viajeIniciado: true
      };

      // Guardar el kilometraje inicial y la hora de inicio en la base de datos
      await firebase.database().ref(`AsignacionViajes/${viajeActualE}`).update(viajeData);

      // Actualizar el estado
      this.setState({
        showKilometrajeInicial: false,
        kmInicial: '',
        showViajeIniciado: true
      });

      //console.log("Viaje iniciado con éxito:", viajeData);
    } catch (error) {
      console.error("Error al iniciar viaje:", error);
    }
  }

  handleBtnFinalizarViajeKmClick = async () => {
    const { kmFinal, comentario } = this.state;

    if (!kmFinal) {
      console.error("Kilometraje final no puede estar vacío.");
      return;
    }

    const confirmacion = window.confirm("¿Seguro que desea finalizar el viaje?");
    if (!confirmacion) {
      return;
    }

    try {
      const currentUser = firebase.auth().currentUser;
      if (!currentUser) {
        console.log("No hay usuario logeado.");
        return;
      }

      const viajeActualERef = firebase.database().ref(`Empleados/${currentUser.uid}/ViajeActualE`);
      const viajeActualESnapshot = await viajeActualERef.once('value');
      const viajeActualE = viajeActualESnapshot.val();

      if (!viajeActualE || viajeActualE === 'ninguno') {
        console.log("No hay viaje asignado.");
        return;
      }

      const viajeData = {
        kmFinal: kmFinal,
        comentario: comentario || '', // Puede ser vacío
        horaFin: Date.now(),
        viajeFinalizado: true
      };

      // Guardar el kilometraje final, comentario y la hora de finalización en la base de datos
      await firebase.database().ref(`AsignacionViajes/${viajeActualE}`).update(viajeData);

      const empleadoData = {
        ViajeActualE: "ninguno",
        viaje: "desactivo",
        viajeActual: "ninguno",
        viajeActualM: "ninguno",
        viajeAsignado: "false",
        viajeEmpresa: "Disponible",
        viajeM: "desactivo"
      };

      // Actualizar los datos del empleado en la base de datos
      await firebase.database().ref(`Empleados/${currentUser.uid}`).update(empleadoData);

      // Actualizar el estado
      this.setState({
        showKilometrajeFinal: false,
        kmFinal: '',
        comentario: ''
      });

      //console.log("Viaje finalizado con éxito:", viajeData);
      //console.log("Datos del empleado actualizados con éxito:", empleadoData);

      // Recargar la página
      window.location.reload();
    } catch (error) {
      console.error("Error al finalizar viaje:", error);
    }
  }

  handleInputKmInicialChange = (event) => {
    this.setState({ kmInicial: event.target.value });
  }

  handleChange = (event) => {
    this.setState({ baseActu: event.target.value });
  }

  handleButtonClick = async () => {
    const { bases, baseActu, userLocation } = this.state;
    const selectedBase = bases.find(base => base.key === baseActu);

    // Validar si la base seleccionada es válida
    if (!selectedBase) {
      this.setState({ showReporteBaseSeleccion: true });
      return;
    }

    //console.log("Base seleccionada", selectedBase);

    // Obtener el usuario logeado actual
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      console.log("No hay usuario logeado.");
      return;
    }

    try {
      // Verificar si el empleado ya se ha reportado
      const reporteExistenteSnapshot = await firebase.database().ref('LaboresEmpresa')
        .orderByChild('emple')
        .equalTo(currentUser.uid)
        .once('value');

      if (reporteExistenteSnapshot.exists()) {
        console.log("Conductor ya reportado en base");
        return;
      }

      // Obtener el tipo de vehículo del usuario logeado
      const empleadoSnapshot = await firebase.database().ref(`Empleados/${currentUser.uid}`).once('value');
      const empleadoData = empleadoSnapshot.val();
      const tipoVehiculo = empleadoData.tipo_vehiculo;

      // Obtener el número de registros actuales en LaboresEmpresa
      const laboresSnapshot = await firebase.database().ref('LaboresEmpresa').once('value');
      const numRegistros = laboresSnapshot.numChildren();

      // Crear un nuevo registro en LaboresEmpresa
      const newRegistro = {
        cooncordancia: numRegistros + 1,
        emple: currentUser.uid,
        estado: "true",
        tipoV: tipoVehiculo,
        base: selectedBase.key
      };

      await firebase.database().ref(`LaboresEmpresa/${numRegistros}`).set(newRegistro);

      // Actualizar la ubicación del usuario en la colección Empleados
      const empleadoUpdateData = {
        latitud: userLocation.lat,
        longitud: userLocation.lng
      };

      await firebase.database().ref(`Empleados/${currentUser.uid}`).update(empleadoUpdateData);

      this.setState({ showEmpleadosHome: false, showEnEspera: true, showReporteBaseExito: true, showReporteBaseError: false, showPasajeros: false, showAbordarPasajero: false });
    } catch (error) {
      console.error("Error al almacenar los datos:", error);
      this.setState({ showEmpleadosHome: false, showEnEspera: false, showReporteBaseExito: false, showReporteBaseError: true, showPasajeros: false, showAbordarPasajero: false });
    }
  }

  handleCloseModal = () => {
    this.setState({ showReporteBaseExito: false, showReporteBaseError: false, showReporteBaseSeleccion: false, showViajeAsignado: false, showPasajeros: false, showAbordarPasajero: false, showExitoAbordarPasajero: false, showLimiteCapacidad: false, showKilometrajeInicial: false, showKilometrajeFinal: false, showPasajerosViajeIniciado: false });
  }

  handleCloseModalViajeIniciado = () => {
    this.setState({ showViajeIniciado: false, showPasajerosViajeIniciado: true });
  }

  handleBtnCloseModalContinuarClick = async () => {
    const { pasajeroTemporal } = this.state;

    if (pasajeroTemporal) {
      const { viajeActualE, clienteId, pasajeroData } = pasajeroTemporal;

      try {
        // Guardar el pasajero en la base de datos
        await firebase.database().ref(`AsignacionViajes/${viajeActualE}/emple/${clienteId}`).set(pasajeroData);

        this.setState({
          showExitoAbordarPasajero: false,
          pasajeroTemporal: null,
          idOrDui: ''
        });
      } catch (error) {
        console.error("Error al guardar pasajero:", error);
      }
    } else {
      this.setState({
        showExitoAbordarPasajero: false
      });
    }
  }

  handleCloseErrorAbordarPasajero = () => {
    this.setState({ showErrorAbordarPasajero: false, showAbordarPasajero: true });
  }

  handleBtnPasajerosClick = () => {
    this.setState({ showPasajeros: true, showViajeAsignado: false });
  }

  handleBtnPasajerosIniciadoClick = () => {
    this.setState({ showPasajerosViajeIniciado: true, showViajeAsignado: false });
  }

  handleBtnViajeClick = () => {
    this.setState({ showViajeAsignado: true, showPasajeros: false });
  }

  handleBtnAbordarPasajeroClick = () => {
    this.setState({ showAbordarPasajero: true, showPasajeros: false, showPasajerosViajeIniciado: false });
  }

  handleBtKmFinalClick = async () => {
    this.setState({ showPasajerosViajeIniciado: false, showKilometrajeFinal: true });
  }

  handleBtnIniciarViajeClick = () => {
    this.setState({ showKilometrajeInicial: true, showPasajeros: false });
  }

  handleBtnNewAbordarPasajeroClick = () => {
    this.setState({ showExitoAbordarPasajero: false, showAbordarPasajero: true });
  }

  handleInputChange = (event) => {
    const value = event.target.value;
    let formattedValue = value.replace(/[^0-9-]/g, '');

    const hyphenCount = (formattedValue.match(/-/g) || []).length;
    if (hyphenCount > 1 || (hyphenCount === 1 && formattedValue.indexOf('-') !== 8)) {
      formattedValue = formattedValue.replace(/-/g, '');
    }

    if (formattedValue.length > 10) {
      formattedValue = formattedValue.slice(0, 10);
    }
  
    this.setState({ idOrDui: formattedValue });
  }

  handleInputKmInicialChange = (event) => {
    this.setState({ kmInicial: event.target.value });
  }

  handleInputKmFinalChange = (event) => {
    this.setState({ kmFinal: event.target.value });
  }

  handleInputComentarioChange = (event) => {
    this.setState({ comentario: event.target.value });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeaderHeight);
    if (this.viajeActualERef) {
      this.viajeActualERef.off();
    }
  }

  getHeaderHeight = () => {
    const width = window.innerWidth;
    if (width <= 320) {
      return 100;
    } else if (width <= 480) {
      return 100;
    } else if (width <= 600) {
      return 150;
    } else {
      return 172;
    }
  };

  updateHeaderHeight = () => {
    this.setState({ headerHeight: this.getHeaderHeight() });
  };

  render() {
    const { userLocation, headerHeight, bases, baseActu, origenName, capacidadVehi, capacidadRestante, cantidadEmple, showEnEspera, showEmpleadosHome, showReporteBaseExito, showReporteBaseError, showReporteBaseSeleccion, showViajeAsignado, showBtnViajeAsignado, showPasajeros, showAbordarPasajero, showExitoAbordarPasajero, showErrorAbordarPasajero, showLimiteCapacidad, showKilometrajeInicial, showViajeIniciado, showPasajerosViajeIniciado, showKilometrajeFinal, showBtnViajeAsignadoIniciado } = this.state;
    const mapHeight = `calc(100vh - ${headerHeight}px)`;

    return (
      <div style={{ position: 'relative', height: mapHeight }}>
        <Mapa
          userLocation={userLocation}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: mapHeight }} />}
          containerElement={<div style={{ height: mapHeight }} />}
          mapElement={<div style={{ height: mapHeight }} />}
        />

        {showEnEspera && (
          <div className="enEspera">
            <img src={enEsperaImg} alt="En espera" className="enEsperaImg" />
          </div>
        )}

        {showEmpleadosHome && (
          <div className="empleadosHome">
            <div className="topDiv">
              Selecciona base
            </div>
            <div className="bottomDiv">
              <div className="row noMargin">
                <img src={baseImg} alt="baseImg" className="modal-image3" />
              </div>
              <div className="row">
                <select className='selectEmpleadosHome' value={baseActu} onChange={this.handleChange}>
                  <option value="" disabled>Seleccione una base</option>
                  {bases.map((snap, index) => (
                    <option key={'opcion2' + index} value={snap.key}>{snap.Nombre}</option>
                  ))}
                </select>
              </div>
              <div className="row">
                <button className='btnEmpleadosHome' onClick={this.handleButtonClick}>Reportarse en base</button>
              </div>
            </div>
          </div>
        )}

        {showReporteBaseExito && (
          <Modal_Conductores
            header="Reporte a base"
            content={
              <React.Fragment>
                <img src={repoBaseExitoso} alt="repoBaseExitoso" className="modal-image" />
                <p>Te has reportado con éxito</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="ajustable"
          />
        )}

        {showReporteBaseSeleccion && (
          <Modal_Conductores
            header="Reporte a base"
            content={
              <React.Fragment>
                <img src={baseImg} alt="baseImg" className="modal-image" />
                <p>Debe de seleccionar una base para continuar</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="ajustable"
          />
        )}

        {showReporteBaseError && (
          <Modal_Conductores
            header="Reporte a base"
            content={
              <React.Fragment>
                <img src={errorImg} alt="errorImg" className="modal-image" />
                <p>Ocurrió un error, inténtalo de nuevo más tarde</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="ajustable"
          />
        )}

        {showViajeAsignado && (
          <Modal_Conductores
            header="Viaje asignado"
            content={
              <React.Fragment>
                <img src={viajeAsignadoImg} alt="viajeAsignadoImg" className="modal-image2" />
                <p className='bold'>Destino: {origenName}</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={false}
            sizeClass="ajustable"
          />
        )}

        {showBtnViajeAsignado && (
          <div className="btnViajeAsignado">
            <button className="btnPasajeros" onClick={this.handleBtnPasajerosClick}>
              <img src={viajeImg} alt="viajeImg" className="viajeImg" />
            </button>
            <button className="btnViaje" onClick={this.handleBtnViajeClick}>Viaje</button>
          </div>
        )}

        {showBtnViajeAsignadoIniciado && (
          <div className="btnViajeAsignado">
            <button className="btnPasajeros" onClick={this.handleBtnPasajerosIniciadoClick}>
              <img src={viajeImg} alt="viajeImg" className="viajeImg" />
            </button>
            <button className="btnViaje" onClick={this.handleBtnViajeClick}>Viaje</button>
          </div>
        )}

        {showPasajeros && (
          <Modal_Conductores
            header="Pasajeros abordados"
            content={
              <React.Fragment>
                <div className="horizontal-align">
                  <p className='bold'>Abordado: {this.state.cantidadEmple}</p>
                  <p className='bold'>Capacidad: {this.state.capacidadVehi}</p>
                </div>
                <p className='bold margin-top' dangerouslySetInnerHTML={{ __html: this.state.pasajerosAbordados }}></p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            button1Text="Abordar pasajero"
            button2Text="Iniciar viaje"
            animate={false}
            sizeClass="alto"
            onButton1Click={this.handleBtnAbordarPasajeroClick}
            onButton2Click={this.handleBtnIniciarViajeClick}
          />
        )}

        {showAbordarPasajero && (
          <Modal_Conductores
            header="Abordar pasajero"
            content={
              <React.Fragment>
                <img src={abordarPasajeroImg} alt="abordarPasajeroImg" className="modal-image3" />
                <p className='bold margin'>Escanear identificación de cliente/s o ingresar DUI</p>
                <div className="horizontal-align2">
                  <div className="centerImg">
                    <img src={qrImg} alt="qrImg" className="duiImg" />
                  </div>
                  <input type="tel" value={this.state.idOrDui} onChange={this.handleInputChange} className="inputDui" placeholder="DUI" />
                </div>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            button1Text="Abordar pasajero"
            animate={false}
            sizeClass="alto"
            onButton1Click={this.agregarPasajero}
          />
        )}

        {showExitoAbordarPasajero && (
          <Modal_Conductores
            header="Abordar pasajero"
            content={
              <React.Fragment>
                <img src={abordarPasajeroImg} alt="abordarPasajeroImg" className="modal-image3" />
                <p className='bold margin'>{this.state.nombreCompleto}</p>
                <p>Pasajero abordado con éxito</p>
                <p className='margin'>Faltan: {this.state.capacidadRestante}</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="medio"
            button1Text="Abordar pasajero"
            button2Text="Continuar"
            onButton1Click={this.handleBtnNewAbordarPasajeroClick}
            onButton2Click={this.handleBtnCloseModalContinuarClick}
          />
        )}

        {showErrorAbordarPasajero && (
          <Modal_Conductores
            header="Abordar pasajero"
            content={
              <React.Fragment>
                <img src={errorImg} alt="errorImg" className="modal-image" />
                <p>El registro del cliente no existe, ingrese un valor válido</p>
              </React.Fragment>
            }
            onClose={this.handleCloseErrorAbordarPasajero}
            animate={true}
            sizeClass="ajustable"
          />
        )}

        {showLimiteCapacidad && (
          <Modal_Conductores
            header="Reporte a base"
            content={
              <React.Fragment>
                <img src={errorImg} alt="errorImg" className="modal-image" />
                <p>Llegó al límite de la capacidad del vehículo, no puede agregar más pasajeros</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="ajustable"
          />
        )}

        {showKilometrajeInicial && (
          <Modal_Conductores
            header="Kilometraje inicial"
            content={
              <React.Fragment>
                <div className="horizontal-align2">
                  <input type="number" value={this.state.kmInicial} onChange={this.handleInputKmInicialChange} className="inputDui" placeholder="Kilometraje" />
                </div>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="ajustable"
            button1Text="Cancelar"
            button2Text="Iniciar viaje"
            onButton1Click={this.handleCloseModal}
            onButton2Click={this.handleBtnIniciarViajeKmClick}
          />
        )}

        {showViajeIniciado && (
          <Modal_Conductores
            header="Viaje iniciado"
            content={
              <React.Fragment>
                <img src={exitoImg} alt="exitoImg" className="modal-image2" />
                <p>Se ha iniciado el viaje</p>
              </React.Fragment>
            }
            onClose={this.handleCloseModalViajeIniciado}
            animate={true}
            sizeClass="ajustable"
            button2Text="Continuar"
            onButton2Click={this.handleCloseModalViajeIniciado}
          />
        )}

        {showPasajerosViajeIniciado && (
          <Modal_Conductores
            header="Pasajeros abordados"
            content={
              <React.Fragment>
                <div className="horizontal-align">
                  <p className='bold'>Abordado: {this.state.cantidadEmple}</p>
                  <p className='bold'>Capacidad: {this.state.capacidadVehi}</p>
                </div>
                <p className='bold margin-top' dangerouslySetInnerHTML={{ __html: this.state.pasajerosAbordados }}></p>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            button1Text="Abordar pasajero"
            button2Text="Finalizar"
            animate={false}
            sizeClass="alto"
            onButton1Click={this.handleBtnAbordarPasajeroClick}
            onButton2Click={this.handleBtKmFinalClick}
          />
        )}

        {showKilometrajeFinal && (
          <Modal_Conductores
            header="Kilometraje final"
            content={
              <React.Fragment>
                <div className="borderKm">
                  <div className="horizontal-align2">
                    <input type="number" value={this.state.kmFinal} onChange={this.handleInputKmFinalChange} className="inputDui" placeholder="Kilometraje" />
                  </div>
                  <br />
                  <div className="horizontal-align2">
                    <input type="text" value={this.state.comentario} onChange={this.handleInputComentarioChange} className="inputDui" placeholder="Comentario" />
                  </div>
                </div>
              </React.Fragment>
            }
            onClose={this.handleCloseModal}
            animate={true}
            sizeClass="ajustable"
            button1Text="Cancelar"
            button2Text="Finalizar viaje"
            onButton1Click={this.handleCloseModal}
            onButton2Click={this.handleBtnFinalizarViajeKmClick}
          />
        )}

      </div>
    );
  }
}

export default Empleados_Home;


// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/Empleados_Home.js